import styled from 'styled-components';

export const StoryWrapper = styled.section`
  padding-top: 2em;
  margin-bottom: 20px;
  border-top: 1px solid #cccccc;

  &:first-of-type {
    border-top: 0;
  }

  &:last-of-type {
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

export const StoryTitle = styled.h1`
  margin-bottom: 5px;
  font-size: 24px;
  line-height: 1.8;
  margin: 0;
  text-decoration: none;

  a {
    color: #2e2e2c;
    background-color: #ADD8E6;
    text-decoration: none;
  }
`;

export const StoryMeta = styled.div`

  > span:first-child {
    margin-right: 10px;
  }

  > span:not(:first-child):before {
    content: '⏲';
    margin: 0 7px;
  }

  .story__meta-bold {
    font-weight: bold;
  }
`;

export const StoryMetaElement = styled.span`
  font-weight: bold;
  color: ${props => props.color};
`;

